import { inject, injectable, named } from '../shared/inversify';
import type { MaybePromise } from './types';
import { ContributionProvider } from './contribution-provider';

export interface LazyLinkOption<T = any, K = string> {
    field: string;
    handler: (context: () => MaybePromise<T>) => MaybePromise<K>;
}

export const LazyLinkService = Symbol.for('LazyLinkService');

export interface LazyLinkService {
    registerLink<T = any>(link: LazyLinkOption<T>): void;
    getLink(field: string): LazyLinkOption | undefined;
    onStart(): void;
}

export const LazyLinkContribution = Symbol.for('LazyLinkContribution');

export interface LazyLinkContribution {
    registerLinks(links: LazyLinkService): void;
}

@injectable()
export class LazyLinkRegistry implements LazyLinkService {
    constructor(
        @inject(ContributionProvider) @named(LazyLinkContribution)
        private _contributionProvider: ContributionProvider<LazyLinkContribution>,
    ) {

    }

    protected readonly _links: { [id: string]: LazyLinkOption } = {};

    onStart(): void {
        this._contributionProvider.getContributions().forEach(contribution => {
            contribution.registerLinks(this);
        });
    }

    registerLink<T = any>(link: LazyLinkOption<T>): void {
        const id = link.field;
        this._links[id] = link;
    }

    getLink<T>(field: string): LazyLinkOption | undefined {
        if (!field) return;
        return this._links[field];
    }
}
